import './douto-banner.css';

/* Banner do Douto. Origem da conversao: utm_source=escoreheart (este site), utm_medium=calculadora,
   utm_campaign=banner_resultado. O clique tambem vai ao Tracking Hub como "douto_cta_click". */
const URL_DOUTO = 'https://douto.app/cardiologia/?utm_source=escoreheart&utm_medium=calculadora&utm_campaign=banner_resultado&utm_content=comecar&utm_term=cardiologia';

export default function DoutoBanner() {
  return (
    <aside className="douto-banner" aria-label="Douto, apoio à decisão clínica">
      <div className="douto-banner__main">
        <p className="douto-banner__eyebrow">Douto · apoio à decisão clínica</p>
        <p className="douto-banner__title">Dor torácica com risco baixo: e agora? <em>Pergunte ao Douto.</em></p>
        <p className="douto-banner__text">Descreva o caso como falaria a um colega e receba conduta estruturada, com referências e limites explícitos. Primeiro caso grátis + 7 dias de garantia após a contratação.</p>
      </div>
      <a className="douto-banner__cta" href={URL_DOUTO} data-th-event="douto_cta_click">
        Fazer primeiro caso grátis <span aria-hidden="true">→</span>
      </a>
    </aside>
  );
}
